<script>
import HKLButton from './HKLButton'

/**
 * @type {import('vue').Component}
 */
const HKLCreateButton = {
  name: 'HKLCreateButton',
  extends: HKLButton,
  props: {
    color: {
      type: String,
      default: 'darkblue',
    },
    action: {
      type: String,
      default: 'create',
    },
  },
}

export default HKLCreateButton
</script>
